export default __webpack_public_path__ + "static/media/ebay-icon.c8428c58.jpg";